<template>
    <v-dialog v-model="dialog" persistent max-width="1200px" fullscreen :retain-focus="false">
        <v-toolbar dark color="primary">
            <v-toolbar-title style="min-width: 400px; ">Envoi d'une demande d'informations</v-toolbar-title>

            <div class="text-right w-100">
                <v-btn icon dark @click="cancel">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
        </v-toolbar>
        <v-stepper @change="setCurrentStep" non-linear :value="currentStep">
            <v-stepper-header>
                <v-stepper-step editable step="1">
                    Informations
                </v-stepper-step>

                <v-stepper-step editable step="2">
                    E-mail
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <information class="container" v-if="tabulations.length" :tabulations="tabulations" :provider="provider" :select-all="true"></information>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <simple-email class="container" :contacts="contacts" :provider="provider" :templates="templates">
                    </simple-email>
                </v-stepper-content>
            </v-stepper-items>

        </v-stepper>
    </v-dialog>
</template>

<script>
import Information from "./stepers/Information"
import { mapMutations, mapState } from "vuex"
import SimpleEmail from "./stepers/SimpleEmail"
export default {
    name: "CreateUniqueFormModal",
    components: { SimpleEmail, Information },
    data() {
        return {
            dialog: false,
            resolve: null,
            reject: null,
            tabulations: [],
            contacts: null,
            provider: null,
            templates: []
        }
    },
    methods: {
        ...mapMutations('createCmaj', ['resetState', 'setCurrentStep', 'setTxtIntro', 'setTxtIntroAspect',
            'setTxtIntroCmaj',]),
        open(tabulations, contact, provider) {
            this.dialog = true
          this.tabulations = tabulations
            this.contacts = [contact]
            this.provider = provider

            return new Promise((resolve, reject) => {
                this.resolve = resolve
                this.reject = reject
            })
        },
        agree() {
            this.resolve(true)

            this.dialog = false
        },
        cancel() {
            this.resolve(false)
            this.dialog = false
        },
        getTemplates() {
            this.$global.loading = true

            this.$http.get('auth/account/email-templates').then(res => {
                this.templates = res.body.data.templates

                this.$global.loading = false
            })
        },
        getAccountIntroTxt() {
            let txtIntroAspect = null
            let txtIntro = null

            if(this.account.configurations.txtIntroAspect) {
                txtIntroAspect = this.account.configurations.txtIntroAspect.value
            }

            if(this.account.configurations.txtIntro) {
                txtIntro = this.account.configurations.txtIntro.value
            }

            if(this.aspect !== undefined && this.aspect !== '') {
                this.setTxtIntro(txtIntroAspect)
            } else {
                this.setTxtIntro(txtIntro)
            }

            this.setTxtIntroAspect(txtIntroAspect)
            this.setTxtIntroCmaj(txtIntro)
        },
    },
    computed: {
        ...mapState('createCmaj', ['currentStep']),
        ...mapState('account', ['account']),
    },
    created() {
        this.resetState()

        this.setCurrentStep(1)

        this.getTemplates()

        this.getAccountIntroTxt()
    },
    destroyed() {
        this.$global.$off('close-update-modal')
    }
}
</script>